import styled from 'styled-components';
import {
  AngleBackIcon,
  CloseDesktopMenuIcon,
  MenuIcon,
} from '@/components/UI/Icons/Icons';
import { Button } from '@/components/UI/Button/Button';

export const DesktopHeaderCloseMenuIcon = styled(CloseDesktopMenuIcon)`
  width: 28px;
  height: 24px;
  margin-right: -1px;
  margin-left: -5px;
  padding: 4px;
`;

export const HeaderAngleBackIcon = styled(AngleBackIcon).attrs(({ theme }) => ({
  fill: theme.palette.primary.labels,
}))``;

export const HeaderMenuIcon = styled(MenuIcon)`
  @media (max-width: 949px) {
    width: 20px;
    height: 17px;
  }

  @media (min-width: 950px) {
    width: 27px;
    height: 24px;
    margin-left: -5px;
    padding: 4px;
  }
`;

export const HeaderLeftActionBtn = styled(Button).attrs({
  appearance: 'transparent',
  hasPadding: false,
})`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    min-width: 20px;
    justify-content: flex-start;
  }

  @media (min-width: 950px) {
    margin-right: 6px;
  }
`;
